import { Accordion, AccordionItem, Col, Collapse, Row } from 'reactstrap';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { useMatch } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { formatUSD } from '../../../../../../helpers/helpers';
import { getTravelInfo } from '../../../slice';
import { Tile } from '../../../../../../Components/Custom/Tile';
import { TravelHub } from '../TravelHub';

export const Travel = () => {
  const { loading, travel } = useAppSelector((state) => state.userDetails);

  const [col, setCol] = useState(true);

  const t_col = () => {
    setCol(!col);
  };

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getTravelInfo(Number(userId)));
  }, [dispatch]);

  return (
    <div>
      <h5>My Travelution Membership Summary</h5>
      <Row>
        <Tile label='Total Travelution orders'>
          {formatUSD(travel?.summary?.totalOrderAmount)}
          <span className='text-muted fs-14'> EUR</span>
        </Tile>
      </Row>

      <Row>
        <Col lg={3}>
          <div className='border border-1 p-3 mb-3 mt-2 card-primary'>
            <h5 className='card-title text-uppercase fs-13'>
              SILVER POOL TICKET{' '}
              <i className={'fs-18 float-end align-middle '}></i>
            </h5>
            <div className='d-flex align-items-center'>
              <div className='card-title muted flex-grow-1 ms-3'>
                <h2 className='card-title mb-0 fs-24'>
                  {' '}
                  {travel?.summary?.silverPoolTickets}
                </h2>
              </div>
            </div>
          </div>
        </Col>
        <Col lg={3}>
          <div className='border border-1 p-3 mb-3 mt-2 card-primary'>
            <h5 className='card-title text-uppercase fs-13'>
              GOLD POOL TICKET{' '}
              <i className={'fs-18 float-end align-middle '}></i>
            </h5>
            <div className='d-flex align-items-center'>
              <div className='card-title muted flex-grow-1 ms-3'>
                <h2 className='card-title mb-0 fs-24'>
                  {' '}
                  {travel?.summary?.goldPoolTickets}
                </h2>
              </div>
            </div>
          </div>
        </Col>
        <Col lg={3}>
          <div className='border border-1 p-3 mb-3 mt-2 card-primary'>
            <h5 className='card-title text-uppercase fs-13'>
              PLATINUM POOL TICKET{' '}
              <i className={'fs-18 float-end align-middle '}></i>
            </h5>
            <div className='d-flex align-items-center'>
              <div className='card-title muted flex-grow-1 ms-3'>
                <h2 className='card-title mb-0 fs-24'>
                  {' '}
                  {travel?.summary?.platinumPoolTickets}
                </h2>
              </div>
            </div>
          </div>
        </Col>
        <Col lg={3}>
          <div className='border border-1 p-3 mb-3 mt-2 card-primary'>
            <h5 className='card-title text-uppercase fs-13'>
              ULTRA-VIP POOL TICKET{' '}
              <i className={'fs-18 float-end align-middle '}></i>
            </h5>
            <div className='d-flex align-items-center'>
              <div className='card-title muted flex-grow-1 ms-3'>
                <h2 className='card-title mb-0 fs-24'>
                  {' '}
                  {travel?.summary?.ultraVipPoolTickets}
                </h2>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Accordion open={'3'}>
        <AccordionItem>
          <h2 className='accordion-header' id='headingTwo'>
            <button
              className={classnames('accordion-button', { collapsed: !col })}
              type='button'
              onClick={t_col}
              style={{ cursor: 'pointer' }}>
              My Travelution Memberships
            </button>
          </h2>
          <Collapse isOpen={col} className='accordion-collapse'>
            <div className='accordion-body'>
              {travel?.userPackages?.map((data, i) => (
                <TravelHub key={i} data={data} />
              ))}
            </div>
          </Collapse>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
